import { initVideoPlay } from "@js/video-play.js";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.image_accordion-layout").forEach((layout) => {
        const items = [...layout.querySelectorAll(".accordion-item")];

        const setOpen = (index) => {
            items.forEach((item, i) => {
                const isOpen = i === index;
                item.classList.toggle("is-open", isOpen);
                item.querySelector(".accordion-toggle")?.setAttribute("aria-expanded", String(isOpen));
            });
        };

        items.forEach((item, index) => {
            item.querySelector(".accordion-toggle")?.addEventListener("click", () => {
                setOpen(item.classList.contains("is-open") ? -1 : index);
            });
        });

        initVideoPlay(layout.querySelector("video"), layout.querySelector(".video-play"));
    });
});
